import ChatHistoryContent from '../../components/chat/history';
import Bot from '../../templates/bot';
import Footer from '../../components/chat/history/footer';
import { Box } from '@mui/joy';
import { Suspense } from 'react';
import Loader from '../../components/chat/history/loader';

export default function ChatHistory() {
	return (
		<Bot title='Chat History' showMenuButton={false} showBackButton>
			<Box
				sx={{
					flex: 1,
					display: 'flex',
					overflowY: 'auto',
					flexDirection: 'column',
					py: 2,
					px: 4,
					scrollbarWidth: 'none', // Firefox
					'&::-webkit-scrollbar': {
						display: 'none', // Chrome, Safari, Edge
					},
				}}
			>
				<Suspense fallback={<Loader />}>
					<ChatHistoryContent />
				</Suspense>
				<Footer />
			</Box>
		</Bot>
	);
}
